// src/hooks/results/useDailyMetricTrend.js

import { useMemo } from "react";
import { buildDailyMetricTrend } from "../../utils/results/buildDailyMetricTrend";

export function useDailyMetricTrend({
  rows,
  language,
  getValue,
  getTimestamp,
}) {
  return useMemo(
    () =>
      buildDailyMetricTrend({
        rows,
        language,
        getValue,
        getTimestamp,
      }),
    [rows, language, getValue, getTimestamp],
  );
}
